"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hmacSHA512 = void 0;
var hmac_1 = require("./noble/hmac.js");
var sha512_1 = require("./noble/sha512.js");
function hmacSHA512(key, data) {
    return new Uint8Array((0, hmac_1.hmac)(sha512_1.sha512, key, data));
}
exports.hmacSHA512 = hmacSHA512;
